var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? _vm.$t("modify") : _vm.$t("add"),
        visible: _vm.dialogShow
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("announcementType"),
                prop: "announce_type"
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("pleaseSelect") },
                  model: {
                    value: _vm.form.announce_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "announce_type", $$v)
                    },
                    expression: "form.announce_type"
                  }
                },
                _vm._l(_vm.AnnouncemenTypeListTow, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("title"), prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseEnterTitle")
                },
                model: {
                  value: _vm.form.title,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("contentSummaryTitle"),
                prop: "content_title"
              }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("pleaseInput") },
                model: {
                  value: _vm.form.content_title,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "content_title", $$v)
                  },
                  expression: "form.content_title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("language"), prop: "language" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("pleaseSelect") },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.language, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("isTop") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("pleaseSelect") },
                  model: {
                    value: _vm.form.top,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "top", $$v)
                    },
                    expression: "form.top"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("yes"), value: 1 }
                  }),
                  _c("el-option", { attrs: { label: _vm.$t("no"), value: 2 } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("serverChannel"), prop: "channel" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("pleaseSelect") },
                  model: {
                    value: _vm.form.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "channel", $$v)
                    },
                    expression: "form.channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.announce_channel_name,
                      value: item.announce_channel_mark
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("status") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v(_vm._s(_vm.$t("enabled")))
                  ]),
                  _c("el-radio", { attrs: { label: 2, border: "" } }, [
                    _vm._v(_vm._s(_vm.$t("disabled")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "pkgs", label: _vm.$t("packageName") }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    placeholder: _vm.$t("pleaseSelectPackageName")
                  },
                  model: {
                    value: _vm.form.pkgs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "pkgs", $$v)
                    },
                    expression: "form.pkgs"
                  }
                },
                _vm._l(_vm.pkgList, function(item) {
                  return _c("el-option", {
                    key: item.pkg,
                    attrs: { label: "" + item.pkg, value: item.pkg }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: _vm.$t("validTime"), prop: "date" }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  type: "datetimerange",
                  align: "right",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("startDate"),
                  "end-placeholder": _vm.$t("endDate")
                },
                model: {
                  value: _vm.form.date,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "date", $$v)
                  },
                  expression: "form.date"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: _vm.$t("content"), prop: "content" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  clearable: "",
                  placeholder: _vm.$t("pleaseEnterContent")
                },
                model: {
                  value: _vm.form.content,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(_vm.form.id)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }